/**
 * Styled Components - Created by miguelcanobbio on 14/08/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  width: 221px;
  margin: 0 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
`

export const Image = styled.img`
  max-width: 160px;
  max-height: 160px;
  background-color: #f1f4f5;
  object-fit: cover;
`

export const Title = styled.div`
  width: 221px;
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
  text-align: center;
`

export const ShareBtn = styled.div`
  position: absolute;
  top: 6px;
  right: 38px;
  color: cornflowerblue;
  font-size: 11.5px;
  &:hover {
    cursor: pointer;
    color: blue;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterInspiration/InspirationItem/styledComponents.tsx